import _get from 'lodash.get';
import { getValidCWVReportingActiveConfigs } from '../../../components/Html/utilities/utils';

const getCwvReportingObj = (info = {}) => {
  const {
    state, // page state
    dataAvailable, // data
    platform,
    browsingPlatform,
    businessProperty,
  } = info;
  if (dataAvailable) {
    const { subsec1: { seolocation1 = '' } = {} } =
      dataAvailable.navsubsecs || {};

    const CWVReportingActiveConfigs =
      getValidCWVReportingActiveConfigs(
        _get(state, `common.siteConfig.CWVReporting`),
        {
          pageName: 'articleshow',
          platform,
          sectionName: seolocation1.toLowerCase(),
        },
      ) || {};

    let { userPercentage } = CWVReportingActiveConfigs;

    if (
      CWVReportingActiveConfigs.sectionWiseUserPercent &&
      Array.isArray(CWVReportingActiveConfigs.sectionWiseUserPercent)
    ) {
      const sectionUserPercent = CWVReportingActiveConfigs.sectionWiseUserPercent.find(
        userPercObj =>
          userPercObj?.section?.toLowerCase() === seolocation1.toLowerCase(),
      );
      userPercentage = sectionUserPercent?.userPercent || userPercentage;
    } else if (
      CWVReportingActiveConfigs.sectionWiseUserPercent &&
      typeof CWVReportingActiveConfigs.sectionWiseUserPercent === 'object'
    ) {
      // this check is added as data coming from xslt site_setting temlate return object if array has 1 item only
      userPercentage =
        CWVReportingActiveConfigs.sectionWiseUserPercent.section?.toLowerCase() ===
        seolocation1.toLowerCase()
          ? CWVReportingActiveConfigs.sectionWiseUserPercent.userPercent
          : userPercentage;
    }
    return {
      userPercentage,
      section: (
        _get(dataAvailable.navsubsecs, 'subsec1.subsecname1') || ''
      ).toLowerCase(),
      subsection: (
        _get(dataAvailable.navsubsecs, 'subsec2.subsecname2') || ''
      ).toLowerCase(),
      browsing_platform: browsingPlatform,
      page_template: 'articleshow',
      business_property: businessProperty,
      dataStore: CWVReportingActiveConfigs.dataStore,
      js: CWVReportingActiveConfigs?.js || {},
      loadJsAt:
        CWVReportingActiveConfigs?.js?.loadJsAt === 'head' ? 'head' : 'body',
    };
  }
  return undefined;
};

export default getCwvReportingObj;
